import { appUrl } from 'utils/wrappers';
import PageableBase from 'app/collections/pageable_base';
import Tracker from 'app/models/tracker';

export default PageableBase.extend({
  model: Tracker,
  key: 'trackers',
  url: appUrl('trackers'),
});



// WEBPACK FOOTER //
// ./app/collections/trackers.js